import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { getActiveLang, getDefaultLang, languageUrl, routePathname } from "../utils/language";

const SITE = "https://fup.odisha.gov.in";
const OG_IMAGE = `${SITE}/og-image.jpg`;
const OG_IMAGE_WIDTH = "1320";
const OG_IMAGE_HEIGHT = "537";
const PUBLISHER = "Department of Agriculture & Farmers' Empowerment, Government of Odisha";
const SITE_NAME = "Krushak Odisha Unified Portal";

const PAGES = {
  "/": {
    en: {
      title: "Krushak Odisha Unified Portal | Farmer Unified Portal for Odisha",
      description:
        "Krushak Odisha Unified Portal (KOUP) is the official Government of Odisha website for farmer schemes, crop and pest advisory, soil health card, and the benefits passbook. Helpline 155333.",
      keywords:
        "Krushak Odisha, Krushak Odisha Unified Portal, KOUP, Farmer Unified Portal, Farmer Unified Portal for Odisha, Odisha farmer portal, Odisha agriculture portal, Krushi Samrudhi Helpline, soil health card Odisha, crop advisory Odisha, pest advisory Odisha, farmer scheme benefits Odisha, benefits passbook Odisha, Ama Krushi, GO Sugam, SAFAL, CM Kisan, Krushi Bhavan, Department of Agriculture and Farmers' Empowerment Odisha",
    },
    ori: {
      title: "କୃଷକ ଓଡ଼ିଶା ୟୁନିଫାଏଡ୍ ପୋର୍ଟାଲ୍ | ଓଡ଼ିଶା ପାଇଁ କୃଷକ ୟୁନିଫାଏଡ୍ ପୋର୍ଟାଲ୍",
      description:
        "କୃଷକ ଓଡ଼ିଶା ୟୁନିଫାଏଡ୍ ପୋର୍ଟାଲ୍ ଓଡ଼ିଶା ସରକାରଙ୍କ ସରକାରୀ ୱେବସାଇଟ୍। ଏଠାରେ କୃଷି ଯୋଜନା, କୃଷି ପରାମର୍ଶ, ମୃତ୍ତିକା ସ୍ୱାସ୍ଥ୍ୟ କାର୍ଡ ଏବଂ ଲାଭ ପାସ୍‌ବୁକ୍ ଉପଲବ୍ଧ। କୃଷି ସମୃଦ୍ଧି ହେଲ୍ପଲାଇନ୍ ୧୫୫୩୩୩।",
      keywords:
        "କୃଷକ ଓଡ଼ିଶା, କୃଷକ ଓଡ଼ିଶା ୟୁନିଫାଏଡ୍ ପୋର୍ଟାଲ୍, ଓଡ଼ିଶା କୃଷକ ପୋର୍ଟାଲ୍, କୃଷି ଯୋଜନା, ମୃତ୍ତିକା ସ୍ୱାସ୍ଥ୍ୟ କାର୍ଡ, କୃଷି ପରାମର୍ଶ, ଲାଭ ପାସ୍‌ବୁକ୍, କୃଷି ସମୃଦ୍ଧି ହେଲ୍ପଲାଇନ୍, କୃଷି ଭବନ, କୃଷି ଓ କୃଷକ ସଶକ୍ତିକରଣ ବିଭାଗ",
    },
  },
  "/about": {
    en: {
      title: "About Us | Krushak Odisha Unified Portal",
      description:
        "About Krushak Odisha Unified Portal, the Government of Odisha one-stop digital platform for farmer services under the Department of Agriculture and Farmers' Empowerment.",
      keywords:
        "About Krushak Odisha, Krushak Odisha Unified Portal, KOUP, Odisha farmer portal, Department of Agriculture and Farmers' Empowerment, Ama Krushi, GO Sugam, SAFAL, CM Kisan",
    },
    ori: {
      title: "ଆମ ବିଷୟରେ | କୃଷକ ଓଡ଼ିଶା ୟୁନିଫାଏଡ୍ ପୋର୍ଟାଲ୍",
      description:
        "କୃଷକ ଓଡ଼ିଶା ୟୁନିଫାଏଡ୍ ପୋର୍ଟାଲ୍ ବିଷୟରେ। ଏହା କୃଷି ଓ କୃଷକ ସଶକ୍ତିକରଣ ବିଭାଗର କୃଷକ ସେବା ପାଇଁ ଏକକ ଡିଜିଟାଲ୍ ପ୍ଲାଟଫର୍ମ।",
      keywords: "ଆମ ବିଷୟରେ, କୃଷକ ଓଡ଼ିଶା, କୃଷକ ଓଡ଼ିଶା ୟୁନିଫାଏଡ୍ ପୋର୍ଟାଲ୍, କୃଷି ଓ କୃଷକ ସଶକ୍ତିକରଣ ବିଭାଗ",
    },
  },
  "/faq": {
    en: {
      title: "FAQs | Krushak Odisha Unified Portal",
      description:
        "Frequently asked questions about Krushak Odisha Unified Portal, farmer services, scheme benefits, advisory, soil health card, and how to use the portal.",
      keywords:
        "Krushak Odisha FAQ, Krushak Odisha Unified Portal, Odisha farmer portal help, scheme benefits FAQ, soil health card Odisha, crop advisory Odisha, benefits passbook Odisha, Krushi Samrudhi Helpline",
    },
    ori: {
      title: "ବାରମ୍ବାର ପଚରା ଯାଇଥିବା ପ୍ରଶ୍ନ | କୃଷକ ଓଡ଼ିଶା ୟୁନିଫାଏଡ୍ ପୋର୍ଟାଲ୍",
      description:
        "କୃଷକ ଓଡ଼ିଶା ୟୁନିଫାଏଡ୍ ପୋର୍ଟାଲ୍ ବିଷୟରେ ବାରମ୍ବାର ପଚରା ଯାଇଥିବା ପ୍ରଶ୍ନ। ଯୋଜନା, କୃଷି ପରାମର୍ଶ, ମୃତ୍ତିକା ସ୍ୱାସ୍ଥ୍ୟ କାର୍ଡ ଏବଂ ପୋର୍ଟାଲ୍ ବ୍ୟବହାର।",
      keywords: "ବାରମ୍ବାର ପଚରା ଯାଇଥିବା ପ୍ରଶ୍ନ, କୃଷକ ଓଡ଼ିଶା, କୃଷି ଯୋଜନା, କୃଷି ପରାମର୍ଶ, ମୃତ୍ତିକା ସ୍ୱାସ୍ଥ୍ୟ କାର୍ଡ, ଲାଭ ପାସ୍‌ବୁକ୍",
    },
  },
  "/termsConditions": {
    en: {
      title: "Terms and Conditions | Krushak Odisha Unified Portal",
      description:
        "Terms and conditions for using the Krushak Odisha Unified Portal, the Government of Odisha farmer website.",
      keywords: "Krushak Odisha terms and conditions, Odisha farmer portal terms",
    },
    ori: {
      title: "ନିୟମ ଏବଂ ସର୍ତ୍ତାବଳୀ | କୃଷକ ଓଡ଼ିଶା ୟୁନିଫାଏଡ୍ ପୋର୍ଟାଲ୍",
      description: "କୃଷକ ଓଡ଼ିଶା ୟୁନିଫାଏଡ୍ ପୋର୍ଟାଲ୍ ବ୍ୟବହାର ପାଇଁ ନିୟମ ଏବଂ ସର୍ତ୍ତାବଳୀ।",
      keywords: "ନିୟମ ଏବଂ ସର୍ତ୍ତାବଳୀ, କୃଷକ ଓଡ଼ିଶା",
    },
  },
  "/privacyPolicy": {
    en: {
      title: "Privacy Policy | Krushak Odisha Unified Portal",
      description:
        "Privacy policy for the Krushak Odisha Unified Portal, explaining how the Government of Odisha farmer website handles information.",
      keywords: "Krushak Odisha privacy policy, Odisha farmer portal privacy",
    },
    ori: {
      title: "ଗୋପନୀୟତା ନୀତି | କୃଷକ ଓଡ଼ିଶା ୟୁନିଫାଏଡ୍ ପୋର୍ଟାଲ୍",
      description: "କୃଷକ ଓଡ଼ିଶା ୟୁନିଫାଏଡ୍ ପୋର୍ଟାଲ୍ର ଗୋପନୀୟତା ନୀତି।",
      keywords: "ଗୋପନୀୟତା ନୀତି, କୃଷକ ଓଡ଼ିଶା",
    },
  },
  "/fup-funnel": {
    en: {
      title: "Download Krushak Odisha App | Farmer Unified Portal",
      description:
        "Download the Krushak Odisha mobile app or open the official farmer portal for schemes, advisory, soil health card, and the benefits passbook.",
      keywords:
        "Krushak Odisha app, download farmer app Odisha, Krushak Odisha Unified Portal, KOUP, soil health card Odisha, benefits passbook Odisha",
    },
    ori: {
      title: "କୃଷକ ଓଡ଼ିଶା ଆପ୍ ଡାଉନଲୋଡ୍ | ୟୁନିଫାଏଡ୍ ପୋର୍ଟାଲ୍",
      description:
        "କୃଷକ ଓଡ଼ିଶା ମୋବାଇଲ୍ ଆପ୍ ଡାଉନଲୋଡ୍ କରନ୍ତୁ କିମ୍ବା ସରକାରୀ ପୋର୍ଟାଲ୍ ଖୋଲନ୍ତୁ। ଯୋଜନା, ପରାମର୍ଶ, ମୃତ୍ତିକା ସ୍ୱାସ୍ଥ୍ୟ କାର୍ଡ ଏବଂ ଲାଭ ପାସ୍‌ବୁକ୍।",
      keywords: "କୃଷକ ଓଡ଼ିଶା ଆପ୍, ମୋବାଇଲ୍ ଆପ୍ ଡାଉନଲୋଡ୍, କୃଷକ ଓଡ଼ିଶା ୟୁନିଫାଏଡ୍ ପୋର୍ଟାଲ୍, ମୃତ୍ତିକା ସ୍ୱାସ୍ଥ୍ୟ କାର୍ଡ, ଲାଭ ପାସ୍‌ବୁକ୍",
    },
  },
};

const SEO = () => {
  const location = useLocation();
  const lang = getActiveLang(location.pathname);
  const isOdia = lang === "ori";
  const pagePath = routePathname(location.pathname);
  const page = PAGES[pagePath];
  const copy = page ? page[lang] : null;
  const canonical = languageUrl(pagePath, lang);
  const enUrl = languageUrl(pagePath, "en");
  const orUrl = languageUrl(pagePath, "ori");
  const defaultUrl = languageUrl(pagePath, getDefaultLang());

  const title = copy ? copy.title : SITE_NAME;
  const description = copy
    ? copy.description
    : "Krushak Odisha Unified Portal is the official farmer website of the Government of Odisha.";
  const imageAlt = isOdia
    ? "କୃଷକ ଓଡ଼ିଶା ୟୁନିଫାଏଡ୍ ପୋର୍ଟାଲ୍: ଓଡ଼ିଶାର କୃଷକ, ଫସଲ, ପଶୁପାଳନ ଏବଂ କୃଷି କାର୍ଯ୍ୟ"
    : "Farmers of Odisha with crops, livestock, and farm work on the Krushak Odisha Unified Portal";
  const locale = isOdia ? "or_IN" : "en_IN";
  const languageName = isOdia ? "Odia" : "English";
  const languageCode = isOdia ? "or" : "en";

  const pageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: title,
    description,
    url: canonical,
    inLanguage: languageCode,
    isPartOf: { "@id": `${SITE}/#website` },
    about: { "@id": `${SITE}/#organization` },
    primaryImageOfPage: {
      "@type": "ImageObject",
      url: OG_IMAGE,
      width: Number(OG_IMAGE_WIDTH),
      height: Number(OG_IMAGE_HEIGHT),
    },
  };

  useEffect(() => {
    document.head.querySelectorAll("[data-seo-static]").forEach((node) => node.remove());
  }, [canonical]);

  return (
    <Helmet
      htmlAttributes={{ lang: languageCode, prefix: "og: https://ogp.me/ns#" }}
      prioritizeSeoTags
    >
      <title>{title}</title>
      <link rel="canonical" href={canonical} />
      <link rel="alternate" hrefLang="en" href={enUrl} />
      <link rel="alternate" hrefLang="or" href={orUrl} />
      <link rel="alternate" hrefLang="x-default" href={defaultUrl} />

      <meta name="description" content={description} />
      {copy?.keywords ? <meta name="keywords" content={copy.keywords} /> : null}
      <meta name="author" content={PUBLISHER} />
      <meta name="publisher" content="Government of Odisha" />
      <meta name="copyright" content="Government of Odisha" />
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <meta name="googlebot" content="index, follow" />
      <meta name="bingbot" content="index, follow" />
      <meta name="language" content={languageName} />
      <meta httpEquiv="content-language" content={languageCode} />
      <meta name="rating" content="general" />
      <meta name="referrer" content="strict-origin-when-cross-origin" />
      <meta name="format-detection" content="telephone=no" />
      <meta name="theme-color" content="#17A53A" />
      <meta name="application-name" content={SITE_NAME} />
      <meta name="apple-mobile-web-app-title" content="Krushak Odisha" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="geo.region" content="IN-OR" />
      <meta name="geo.placename" content="Bhubaneswar, Odisha, India" />
      <meta name="dcterms.title" content={title} />
      <meta name="dcterms.description" content={description} />
      <meta name="dcterms.language" content={languageCode} />
      <meta name="dcterms.publisher" content={PUBLISHER} />
      <meta name="dcterms.coverage" content="Odisha, India" />

      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:locale" content={locale} />
      <meta property="og:locale:alternate" content={isOdia ? "en_IN" : "or_IN"} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta property="og:image:secure_url" content={OG_IMAGE} />
      <meta property="og:image:type" content="image/jpeg" />
      <meta property="og:image:width" content={OG_IMAGE_WIDTH} />
      <meta property="og:image:height" content={OG_IMAGE_HEIGHT} />
      <meta property="og:image:alt" content={imageAlt} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={OG_IMAGE} />
      <meta name="twitter:image:alt" content={imageAlt} />
      <meta name="twitter:url" content={canonical} />

      <script type="application/ld+json">{JSON.stringify(pageSchema)}</script>
    </Helmet>
  );
};

export default SEO;
